import { jsx as E } from "react/jsx-runtime";
import { BadRequest as M } from "@systemeio/util";
import { useStore as P } from "../../../../store/index.mjs";
import { stripeCardBuyOffer as S, confirmPaymentIntent as g } from "../../api/stripe-api.mjs";
import { getStripeCardConfirmHandler as x } from "../utils/get-stripe-card-confirm-handler.mjs";
import { useStripe as b, useElements as k, ExpressCheckoutElement as F } from "../../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { PaymentMethodEnum as q } from "@systemeio/ui";
import { useRollbar as B } from "@rollbar/react";
function T({
  setIsFetching: p,
  handleBadRequest: f,
  setErrors: c,
  preSubmit: l
}) {
  const r = b(), t = k(), y = B(), { locale: d } = P();
  return /* @__PURE__ */ E(
    F,
    {
      options: {
        paymentMethods: {
          applePay: "always",
          googlePay: "never",
          amazonPay: "never",
          link: "never",
          paypal: "never"
        }
      },
      onConfirm: async (o) => {
        if (!(!r || !t))
          try {
            const e = l();
            if (!e) return;
            const { error: u } = await t.submit();
            if (u) {
              o.paymentFailed();
              return;
            }
            const { error: h, paymentMethod: n } = await r.createPaymentMethod({
              elements: t
            });
            if (h || !n) {
              o.paymentFailed();
              return;
            }
            const { redirect: a, intentSecret: i, intentType: w } = await S(
              {
                ...e,
                paymentMethod: q.stripe_applepay,
                options: { stripePaymentMethodId: n.id }
              },
              d
            );
            if (!i) return window.location.href = a;
            const C = x(r, w), { error: m } = await C(i, {
              payment_method: n.id
            });
            m ? c((s) => ({
              ...s,
              common: [...s.common, m.message]
            })) : (await g(), window.location.assign(a));
          } catch (e) {
            o.paymentFailed({ reason: "fail" }), e instanceof M ? f(e) : y.error("Stripe Express Checkout Confirmation Error", e);
          } finally {
            p(!1);
          }
      }
    }
  );
}
export {
  T as StripeExpressCheckout
};
